export default {
  small: '4px',
  medium: '20px',
  large: '100px',
} as const;
